"use client";

import { useState } from "react";
import { Bell, BellRing } from "lucide-react";
import { Button } from "@/components/catalyst/button";
import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "@/components/catalyst/dialog";
import { Input } from "@/components/catalyst/input";
import { useMediaQuery } from "usehooks-ts";
import { motion, AnimatePresence } from "motion/react";

export function SubscribeButton() {
  const isMobile = useMediaQuery("(max-width: 640px)");
  const [isOpen, setIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const iconVariants = {
    hidden: { opacity: 1, scale: 0.8, rotate: -12 },
    visible: { opacity: 1, scale: 1, rotate: 0 },
  };

  return (
    <>
      <Button
        name="Subscribe Button"
        outline
        onClick={() => setIsOpen(true)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <AnimatePresence mode="wait">
          {isHovered ? (
            <motion.div
              key="ringing"
              variants={iconVariants}
              initial="hidden"
              animate="visible"
              exit="hidden"
              transition={{ duration: 0.3, ease: "easeInOut" }}
            >
              <BellRing className="size-4" />
            </motion.div>
          ) : (
            <motion.div
              key="bell"
              variants={iconVariants}
              initial="hidden"
              animate="visible"
              exit="hidden"
              transition={{ duration: 0.3, ease: "easeInOut" }}
            >
              <Bell className="size-4" />
            </motion.div>
          )}
        </AnimatePresence>
        Subscribe
      </Button>
      <Dialog open={isOpen} onClose={setIsOpen}>
        <DialogTitle>Subscribe</DialogTitle>
        <DialogBody>
          <form
            action="https://buttondown.email/api/emails/embed-subscribe/karl"
            method="post"
            target="popupwindow"
            onSubmit={() => {
              window.open("https://buttondown.email/karl", "popupwindow");
              setIsOpen(false);
              return true;
            }}
            className="embeddable-buttondown-form"
          >
            <fieldset className="mb-4 flex flex-col items-start gap-2 font-sans">
              <div className="flex w-full gap-2">
                <Input
                  type="email"
                  name="email"
                  aria-label="Your email input"
                  id="bd-email"
                  placeholder="hello@email.com"
                  required
                  className="flex-1"
                />
                <Button type="submit" name="Subscribe" aria-label="Subscribe">
                  Subscribe
                </Button>
              </div>
              <input type="hidden" value="1" name="embed" />
            </fieldset>
          </form>
          <div className="flex w-full justify-start gap-1 text-sm">
            <span className="text-stone-600 dark:text-stone-400">
              Or you can subscribe via
            </span>
            <a
              href="https://kejk.tech/rss.xml"
              target="_blank"
              rel="noopener noreferrer"
              className="text-foreground-700 hover:text-primary font-medium underline decoration-2 underline-offset-2"
            >
              RSS
            </a>
          </div>
        </DialogBody>
      </Dialog>
    </>
  );
}
